/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAssetDto } from '../models/CreateAssetDto';
import type { UpdateAssetDto } from '../models/UpdateAssetDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssetsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Listar activos (paginado)
   * @returns any Lista de activos con paginación
   * @throws ApiError
   */
  public assetsControllerFindAll({
    page = 1,
    limit = 10,
    search,
    assetTypeId,
    locationId,
    status,
    sortBy = 'createdAt',
    sortOrder = 'desc',
    includeDeleted,
    upcomingMaintenance,
  }: {
    /**
     * Número de página (1-indexed)
     */
    page?: number,
    /**
     * Cantidad de registros por página
     */
    limit?: number,
    /**
     * Búsqueda por nombre, código o número de serie
     */
    search?: string,
    /**
     * Filtrar por tipo de activo
     */
    assetTypeId?: string,
    /**
     * Filtrar por ubicación
     */
    locationId?: string,
    /**
     * Filtrar por estado del activo
     */
    status?: 'ACTIVE' | 'IN_MAINTENANCE' | 'INACTIVE' | 'DISPOSED',
    /**
     * Campo de ordenamiento
     */
    sortBy?: 'name' | 'code' | 'brand' | 'model' | 'status' | 'createdAt' | 'updatedAt' | 'nextMaintenanceDate',
    /**
     * Dirección de ordenamiento
     */
    sortOrder?: 'asc' | 'desc',
    /**
     * Incluir activos eliminados (soft deleted)
     */
    includeDeleted?: 'true' | 'false',
    /**
     * Filtrar por próximo mantenimiento (entre hoy y hoy + 30 días)
     */
    upcomingMaintenance?: boolean,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/assets',
      query: {
        'page': page,
        'limit': limit,
        'search': search,
        'assetTypeId': assetTypeId,
        'locationId': locationId,
        'status': status,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
        'includeDeleted': includeDeleted,
        'upcomingMaintenance': upcomingMaintenance,
      },
      errors: {
        401: `No autenticado`,
      },
    });
  }
  /**
   * Crear nuevo activo
   * @returns any Activo creado exitosamente
   * @throws ApiError
   */
  public assetsControllerCreate({
    requestBody,
  }: {
    requestBody: CreateAssetDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/assets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos, campos requeridos faltantes o campos personalizados inválidos`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Tipo de activo o ubicación no encontrados`,
      },
    });
  }
  /**
   * Obtener activo por ID
   * @returns any Detalles del activo
   * @throws ApiError
   */
  public assetsControllerFindOne({
    id,
  }: {
    /**
     * ID del activo (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/assets/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `No autenticado`,
        404: `Activo no encontrado`,
      },
    });
  }
  /**
   * Actualizar activo
   * @returns any Activo actualizado exitosamente
   * @throws ApiError
   */
  public assetsControllerUpdate({
    id,
    requestBody,
  }: {
    /**
     * ID del activo (UUID)
     */
    id: string,
    requestBody: UpdateAssetDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/assets/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos o campos personalizados inválidos`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Activo o ubicación no encontrados`,
      },
    });
  }
  /**
   * Eliminar activo (soft delete)
   * @returns any Activo eliminado exitosamente
   * @throws ApiError
   */
  public assetsControllerRemove({
    id,
  }: {
    /**
     * ID del activo (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/assets/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Activo no encontrado`,
      },
    });
  }
  /**
   * Obtener historial de cambios del activo
   * @returns any Historial de auditoría del activo
   * @throws ApiError
   */
  public assetsControllerGetAuditLogs({
    id,
    page = 1,
    limit = 20,
    entityType,
    entityId,
    action,
    userId,
    sortBy = 'createdAt',
    sortOrder = 'desc',
  }: {
    /**
     * ID del activo (UUID)
     */
    id: string,
    /**
     * Page number (1-indexed)
     */
    page?: number,
    /**
     * Items per page
     */
    limit?: number,
    /**
     * Filter by entity type
     */
    entityType?: 'Organization' | 'User' | 'Location' | 'AssetType' | 'Asset' | 'Maintenance' | 'Movement',
    /**
     * Filter by entity ID (UUID)
     */
    entityId?: string,
    /**
     * Filter by action type
     */
    action?: 'CREATE' | 'UPDATE' | 'DELETE',
    /**
     * Filter by user ID (UUID)
     */
    userId?: string,
    /**
     * Order by field
     */
    sortBy?: 'createdAt',
    /**
     * Sort order
     */
    sortOrder?: 'asc' | 'desc',
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/assets/{id}/audit-logs',
      path: {
        'id': id,
      },
      query: {
        'page': page,
        'limit': limit,
        'entityType': entityType,
        'entityId': entityId,
        'action': action,
        'userId': userId,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        401: `No autenticado`,
        404: `Activo no encontrado`,
      },
    });
  }
}
